import colors from "../../assets/theme/base/colors";
import typography from "../../assets/theme/base/typography";
import borders from "../../assets/theme/base/borders";
import boxShadows from "../../assets/theme/base/boxShadows";

import pxToRem from "../../assets/theme/functions/pxToRem";

/** Styles the merchant workspace selector with a dropdown indicator for multiple merchants. */
export default (selectSize, selectError, selectSuccess) => {
  const { dark, white, text, light, inputColors, brand, grey } = colors;
  const { size, fontWeightRegular } = typography;
  const { borderRadius } = borders;
  const { inputBoxShadow, lg } = boxShadows;

  let borderColor = "#d8d8d0";
  let borderColorFocused = inputColors.borderColor.focus;
  let focusShadow = inputBoxShadow.focus;

  if (selectError) {
    borderColor = inputColors.error;
    borderColorFocused = inputColors.error;
    focusShadow = inputBoxShadow.error;
  } else if (selectSuccess) {
    borderColor = inputColors.success;
    borderColorFocused = inputColors.success;
    focusShadow = inputBoxShadow.success;
  }

  return {
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      minHeight: pxToRem(60),
      padding: "12px 10px",
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      backgroundColor: white.main,
      border: "1px solid " + (state.isFocused ? borderColorFocused : borderColor),
      borderRadius: borderRadius.lg,
      cursor: "pointer",
      boxShadow: state.isFocused ? focusShadow : "none",
      transition: "box-shadow 150ms ease, border-color 150ms ease",
      "&:hover": { borderColor: borderColorFocused },
    }),
    valueContainer: (provided) => ({
      ...provided,
      minWidth: 0,
      padding: 0,
      color: dark.main,
    }),
    singleValue: (provided) => ({
      ...provided,
      maxWidth: "100%",
      margin: 0,
      color: dark.main,
    }),
    placeholder: (provided) => ({ ...provided, margin: 0, color: text.main }),
    input: (provided) => ({ ...provided, margin: 0, padding: 0, color: dark.main }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      display: state.options.length > 1 ? "flex" : "none",
      padding: "0 0 0 6px",
      color: text.main,
      "& svg": {
        width: pxToRem(16),
        height: pxToRem(16),
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0)",
        transition: "transform 250ms ease",
      },
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: pxToRem(6),
      padding: pxToRem(6),
      border: "1px solid " + grey[300],
      borderRadius: borderRadius.lg,
      backgroundColor: white.main,
      boxShadow: lg,
      fontSize: size.xs,
      color: dark.main,
      textAlign: "left",
    }),
    menuList: (provided) => ({ ...provided, padding: 0 }),
    option: (provided, state) => ({
      ...provided,
      padding: "10px 8px",
      borderRadius: borderRadius.md,
      color: dark.main,
      backgroundColor: state.isSelected ? brand.soft : state.isFocused ? light.main : white.main,
      cursor: state.isDisabled ? "not-allowed" : "pointer",
      opacity: state.isDisabled ? 0.5 : 1,
      transition: "background-color 150ms ease",
      "&:hover, &:active": {
        backgroundColor: state.isSelected ? brand.soft : light.main,
      },
    }),
  };
};
